"use client";

import { useEffect } from "react";
import { fireUniversalSitePixel, isTvSciProdHost, loadTvSciPixel } from "@/lib/analytics/tvScientific";

// Loads the TV Scientific SDK site-wide (production hosts only) and fires the
// universal site pixel once per session. Renders nothing.
export function TvScientificPixel() {
  useEffect(() => {
    if (!isTvSciProdHost()) return;
    loadTvSciPixel()
      .then(fireUniversalSitePixel)
      .catch(() => {});
  }, []);

  return null;
}
